import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function fetchNfeItem(accessKey) {
  const url = new URL(`/items/${accessKey}`, API_BASE_URL);

  const response = await fetch(url.toString());
  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar itens"));
  }

  return data;
}

export async function fetchDocumentosNfe(accessKey) {
  const url = new URL(`/documentos_nfe/${accessKey}`, API_BASE_URL);

  const response = await fetch(url.toString());
  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Resposta inválida do servidor");
  }

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao buscar documentos"));
  }

  return data;
}
